
<template>
  <div class="text-component" ref="html-component">
    <div
      :class="[block.dimension, block.alignment]"
      v-for="(block, key) in payload.textBlocks"
      :key="key"
      v-html="block.text"
    ></div>
  </div>
</template>
<script>
export default {
  props: {
    payload: {
      default: {}
    }
  },
  mounted() {
    this.initListener();
  },
  methods: {
    initListener() {
      this.$refs["html-component"].addEventListener("click", e => {
        if (e.target && e.target.nodeName === "A") {
          let href = e.target.getAttribute("href");
          if (href.slice(0, 4) === "http") {
            return;
          }
          e.preventDefault();
          this.$router.push(href);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";
.text-component {
  @include breakpoint(medium down) {
    text-align: left !important;
  }
  & > div {
    margin-top: 32px;
    margin-bottom: 32px;
    @include breakpoint(1220px down) {
      text-align: left;
    }
    @include breakpoint(medium down) {
      margin-top: 16px;
      margin-bottom: 16px;
    }
    &:first-of-type {
      margin-top: 0;
    }
    &:last-of-type {
      margin-bottom: 0;
    }

    &.medium {
      /deep/ * {
        font-size: 24px;
        line-height: 28px;
        @include breakpoint(small only) {
          font-size: 22px;
        }
      }
    }
    &.bigger {
      /deep/ * {
        font-size: 32px;
        line-height: 36px;
        @include breakpoint(small only) {
          font-size: 24px;
          line-height: 30px;
        }
      }
    }
    &.title {
      /deep/ * {
        font-size: 42px;
        line-height: 42px;
        font-weight: $global-weight-bold;
        @include breakpoint(small only) {
          font-size: 30px;
          line-height: 34px;
        }
      }
    }

    /deep/ * {
      font-size: 18px;
      line-height: 24px;
      font-weight: $global-weight-normal;
    }
    /deep/ b,
    /deep/ strong {
      font-weight: $global-weight-bold;
    }
    /deep/ a {
      font-weight: $global-weight-bold;
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
